import SEO from '../../components/SEO.js';
import Header from '../../components/font/header1.js';
import HeaderLine from '../../components/font/headerline.js';
import Header2 from '../../components/font/header2.js';
import SubHeader from '../../components/font/subheader';
import user_with_phone from '../../img/user_with_phone.png'
import Threebox from '../../components/layout/threebox.js';
import PriceCards from '../../components/PriceCards/PriceCards.js';
import Navbar from '../../components/navbar/Navbar.js';
import Footer from '../../components/footer/Footer.js';
import TagManager from 'react-gtm-module';
import WhatWeDo from '../../components/whatWeDo/WhatWeDo.js';
import Services from '../../components/services/Services.js';
import Marketplace from '../../components/marketplace/Marketplace.js';
import AppPreview from '../../components/appPreview/AppPreview.js';
import LocationsTeaser from '../../components/locationsTeaser/LocationsTeaser.js';

const APP_SIGNUP_URL = 'https://app.homebutler.us';

const tagManagerArgs = {
    dataLayer: {
        page: 'home'
    },
    dataLayerName: 'PageDataLayer'
}

function Homepage() {

    TagManager.dataLayer(tagManagerArgs)

    const homeSchema = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "HomeButler",
        "applicationCategory": "HomeUtility",
        "description": "Home Operating System and Digital Asset Logbook. AI-driven task triage and home health score dashboard.",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
        }
    };

    return (
        <>
            <SEO
                title="HomeButler | The Home Operating System"
                description="Your Home OS. Track your home's health, keep a digital asset logbook, and let AI triage your maintenance. Protect your home's value."
                schemaData={homeSchema}
                path="/"
            />
            <div>
                <Navbar links={true}/>
                <div id='section1' className='flex flex-col lg:flex-row lg:justify-evenly justify-center pl-12 pr-12'>
                    <div className='flex flex-col lg:w-1/3'>
                        <SubHeader>Your Property's Control Center</SubHeader>
                        <Header left='True'>The Ultimate Home Operating System</Header>
                        <p className='pt-5'>A proactive, data-driven Home Health dashboard that tracks the condition and risks of your home's assets (HVAC, Roof, Appliances). Say goodbye to paper manuals and let our AI handle maintenance triage so you can protect your most valuable asset.</p>
                        <a href={APP_SIGNUP_URL} className='mt-6 bg-pink rounded-full h-14 text-white flex items-center justify-center w-fit px-10'>Sign up free</a>
                    </div>
                    <div className='lg:place-self-end place-self-center'>
                        <img src={user_with_phone} alt="person with phone" className='h-96 place-self-center ' />
                    </div>
                </div>
                <div id='section2' className='z-0 h-fit bg-lightblue'>
                    <WhatWeDo />
                </div>
                <div id='section25' className='flex flex-col justify-center py-16 lg:py-24 lg:p-10 bg-darkblue'>
                    <Services />
                </div>
                <div id='section3'>
                    <AppPreview />
                </div>
                <div id='section35'>
                    <Marketplace />
                </div>
                <div id='section4' className='flex flex-col justify-center pt-16 lg:pt-24 lg:p-10 bg-darkblue'>
                    <div className='flex flex-row'>
                        <HeaderLine />
                        <div className='flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4'>
                            <Header white='True'>Pricing</Header>
                        </div>
                        <HeaderLine />
                    </div>
                    <Header2>Choose what plan is best for You</Header2>
                    <p className='text-white text-center -mt-2 pb-4'>Start free — no card required</p>
                    <Threebox>
                        <PriceCards />
                    </Threebox>
                </div>
                <LocationsTeaser />
                <Footer links={true}/>
            </div>
        </>
    )
};

export default Homepage;